import { useEffect, useMemo, useState } from "react";
import { API_BASE } from "../lib/api";

type Props = { name: string; picture?: string };

function securePictureUrl(picture?: string) {
  if (!picture) return undefined;
  try {
    const url = new URL(picture, "https://api-security.miglioresoftware.com");
    if (url.protocol !== "http:" && url.protocol !== "https:") return undefined;
    url.protocol = "https:";
    // L'avatar di Security è same-site solo con .com: lo serve il nostro Worker, same-site con la UI su .app.
    const opaque = url.hostname === "api-security.miglioresoftware.com" ? url.pathname.match(/^\/api\/avatar\/([\w-]{8,200})$/)?.[1] : undefined;
    return opaque ? `${API_BASE}/api/avatar/${opaque}` : url.href;
  } catch {
    return undefined;
  }
}

export function UserAvatar({ name, picture }: Props) {
  const source = useMemo(() => securePictureUrl(picture), [picture]);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [source]);

  if (source && !failed) {
    return <img className="user-avatar" src={source} alt="" referrerPolicy="no-referrer" onError={() => setFailed(true)} />;
  }

  const initial = name.trim().charAt(0).toLocaleUpperCase("it-IT") || "U";
  return <span className="user-avatar user-avatar-fallback" aria-hidden="true">{initial}</span>;
}
